var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8356 14.29L22.5687 9.21938C22.1474 8.81359 21.5153 8.81359 21.094 9.21938C20.6727 9.62491 20.6727 10.2335 21.094 10.6393L24.57 13.9858H14.4577C13.8256 13.9858 13.4043 14.3913 13.4043 14.9999C13.4043 15.6084 13.8256 16.0139 14.4577 16.0139H24.57L21.0943 19.3605C20.6729 19.7663 20.6729 20.3748 21.0943 20.7803C21.305 20.9834 21.5156 21.0846 21.8315 21.0846C22.1477 21.0846 22.3583 20.9831 22.569 20.7803L27.8358 15.6084C27.8358 15.6084 27.8358 15.5069 27.9413 15.5069C28.2572 15.2026 28.2572 14.5943 27.8358 14.2901L27.8356 14.29Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9905 22.0989C24.3585 22.0989 23.9372 22.5047 23.9372 23.1129V25.1414C23.9372 25.7497 23.5158 26.1555 22.8838 26.1555H4.97651C4.34449 26.1555 3.92314 25.7497 3.92314 25.1414V4.85865C3.92314 4.25036 4.34449 3.84457 4.97651 3.84457H22.8838C23.5158 3.84457 23.9372 4.25036 23.9372 4.85865V6.88708C23.9372 7.4954 24.3585 7.90116 24.9905 7.90116C25.6225 7.90116 26.0439 7.49537 26.0439 6.88708V4.85865C26.0439 3.13477 24.6747 1.81641 22.8838 1.81641H4.97651C3.18592 1.81641 1.81641 3.13477 1.81641 4.85865V25.1414C1.81641 26.8653 3.18595 28.1836 4.97651 28.1836H22.8838C24.6746 28.1836 26.0439 26.8653 26.0439 25.1414V23.1129C26.0439 22.5046 25.6225 22.0989 24.9905 22.0989Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.f6a5d63388e658e03168d11f49d521fb.svg";
export { ForwardRef as ReactComponent };